import { useEffect, useRef } from "react";
import { todayKey } from "../../shared/dates";
import { rollKeyDateOn } from "./keyDateService";
import { repeatOf } from "./keyDates";

// Moves each repeating Key Date whose day has passed on to its next one (next week, month or year). NudgeApp runs it, so a date moves
// whichever page is open. Each date is tried once per session (by id and date, so a date that has moved
// can move again next time); one that fails is tried again next time the app opens.
export function useRepeatRollover(uid, keyDates) {
  const tried = useRef(new Set());
  useEffect(() => {
    if (!uid) return;
    const today = todayKey();
    (keyDates || []).filter(k => repeatOf(k) && k.date && k.date < today).forEach(k => {
      const id = `${k.id}:${k.date}`;
      if (tried.current.has(id)) return;
      tried.current.add(id);
      rollKeyDateOn(uid, k.id).catch(e => console.error("Moving a repeating key date failed:", e));
    });
  }, [uid, keyDates]);
}
